import {
  div,
  h1,
  h2,
  p,
  table,
  thead,
  tbody,
  tr,
  th,
  td,
  span,
  input,
  fnstate
} from '@srfnstack/fntags'
import { creditActions } from '../state.js'

export const Help = () => {
  const helpData = fnstate({ sections: [], loading: true })
  const searchTerm = fnstate('')

  const fetchHelp = async () => {
    try {
      const res = await fetch('/api/system/help-data')
      if (res.ok) {
        helpData({ sections: (await res.json()).sections, loading: false })
      }
    } catch (err) {
      console.error('Error fetching help:', err)
    }
  }

  fetchHelp()

  const filterSections = (sections, term) => {
    if (!term) return sections
    const t = term.toLowerCase()
    return sections.map(s => ({
      ...s,
      articles: s.articles.filter(a =>
        a.title.toLowerCase().includes(t) ||
        a.content.toLowerCase().includes(t)
      )
    })).filter(s => s.articles.length > 0)
  }

  return div({ class: 'p-6 max-w-5xl mx-auto space-y-8' },
    div({ class: 'flex flex-col md:flex-row justify-between items-start md:items-center gap-4' },
      h1({ class: 'text-3xl font-bold' }, 'Help & Documentation'),
      input({
        type: 'text',
        placeholder: 'Search documentation...',
        class: 'input input-bordered w-full md:w-64',
        oninput: (e) => searchTerm(e.target.value)
      })
    ),

    div({ class: 'grid grid-cols-1 lg:grid-cols-3 gap-8' },
      // Left Column: Dynamic Docs
      div({ class: 'lg:col-span-2 space-y-6' },
        helpData.bindAs(hd => {
          if (hd.loading) return div({ class: 'text-center p-12' }, span({ class: 'loading loading-spinner loading-lg' }))

          const filtered = filterSections(hd.sections, searchTerm())
          if (filtered.length === 0) return div({ class: 'text-center p-12 opacity-50' }, 'No articles found matching your search.')

          return div(filtered.map(s => div({ class: 'space-y-4' },
            h2({ class: 'text-xs uppercase font-black tracking-[0.2em] text-primary opacity-70 mb-2' }, s.title),
            s.articles.map(a => div({ class: 'card bg-base-200 border border-base-300 shadow-sm p-6' },
              h2({ class: 'text-lg font-bold mb-2' }, a.title),
              p({ class: 'text-sm opacity-80 leading-relaxed' }, a.content)
            ))
          )))
        })
      ),

      // Right Column: System Status & Costs
      div({ class: 'space-y-6' },
        div({ class: 'card bg-primary text-primary-content p-6 shadow-xl' },
          h2({ class: 'font-bold mb-2 flex items-center gap-2' }, span({ class: 'material-symbols-rounded text-primary-content' }, 'token'), 'Credit System'),
          p({ class: 'text-xs opacity-90' }, 'EtherBuildr uses a credit-based system for AI operations. Each task triggers automated deductions from your balance.')
        ),

        div({ class: 'card bg-base-200 border border-base-300 shadow-sm overflow-hidden' },
          div({ class: 'p-4 border-b border-base-300 bg-base-300/30' },
            h2({ class: 'font-bold text-xs uppercase tracking-widest opacity-60' }, 'Action Costs')
          ),
          table({ class: 'table table-compact w-full' },
            thead(tr(th('Action'), th('Cost'))),
            creditActions.bindAs(actions => tbody(actions.map(a => tr(
              td({ class: 'text-xs font-bold' }, a.name),
              td(span({ class: 'badge badge-sm badge-primary font-bold' }, `${a.cost}`))
            ))))
          )
        ),

        div({ class: 'card bg-base-200 border border-base-300 shadow-sm p-6' },
          h2({ class: 'text-xs uppercase font-bold opacity-50 tracking-widest mb-4' }, 'Automation Path'),
          div({ class: 'steps steps-vertical w-full text-xs' },
            div({ class: 'step step-primary' }, 'Upscale'),
            div({ class: 'step step-primary' }, 'AI SEO'),
            div({ class: 'step step-primary' }, 'Mockups'),
            div({ class: 'step' }, 'Publish')
          )
        )
      )
    )
  )
}
